import './style.css';
import Logo from 'assets/ActusIcone2025x1024.png';
import {useEffect, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import apibasic from 'services/apibasic';
import SaltPassword from 'services/md5';
import NavbarVisitante from 'components/navbarvisitante';
import LoginModal from '../login/modal';
import DLGMESSAGE from 'components/dlgmensagem';
import config from 'config';
import SelectCidade from 'components/SelectCidade';

function Cadastro() {
    const navigate = useNavigate();
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [senha2, setSenha2] = useState('');
    const [endereco, setEndereco] = useState('');
    const [complemento, setComplemento] = useState('');
    const [bairro, setBairro] = useState('');
    const [cidade, setCidade] = useState('');
    const [codCidade, setCodCidade] = useState('');
    const [uf, setUf] = useState('');
    const [cep, setCEP] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [loading, setLoading] = useState('');
    const [cidades, setCidades] = useState([]);
    const [numero, setNumero] = useState('');
    const [whatsup, setWhatsup] = useState('');
    const [whatsup2, setWhatsup2] = useState('');
    const [dlgmessage, setDLGMessage] = useState('');
    const [ppdlgmessage, setPPDLGMessage] = useState(false);
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

    const openLoginModal = () => setIsLoginModalOpen(true);
    const closeLoginModal = () => setIsLoginModalOpen(false);

    function SalvarCidade(e) {
        const [cid, est] = e.target[e.target.selectedIndex].text.split(' - ');
        setCidade(cid);
        setUf(est);
        setCodCidade(e.target.value);
    }

    function ProcessaCadastro(e) {
        e.preventDefault();
        setMensagem('');

        if (senha !== senha2) {
            setMensagem('Senhas não conferem');
            return;
        }

        if (whatsup !== whatsup2) {
            setMensagem('Numero do WhatsUp não conferem');
            return;
        }

        setLoading(true);

        apibasic.post('v1/usuarios/registro', {
            nome,
            email,
            senha: senha.length > 0 ? SaltPassword(senha) : '',
            whatsup,
            endereco,
            numero,
            complemento,
            bairro,
            cidade,
            uf,
            cep,
            cod_cidade: codCidade
        })
            .then(response => {
                if (response.status === 201) {
                    localStorage.setItem('eamigaToken', response.data.token);
                    localStorage.setItem('eamigaId', response.data.id_usuario);
                    localStorage.setItem('eamigaEmail', email);
                    localStorage.setItem('eamigaCodCidade', codCidade);
                    localStorage.setItem('eamigaUF', uf);
                    localStorage.setItem('eamigaCidade', cidade);
                    setDLGMessage('Cadastro realizado com sucesso');
                    setPPDLGMessage(true);
                    setLoading(false);
                } else {
                    setLoading(false);
                    setMensagem('Ocorreu um erro no cadastro ' + response.response.data.erro);
                }
            })
            .catch(err => {
                setLoading(false);
                setMensagem(err.response.data.erro);
            })
    }

    function confirmaCad() {
        setPPDLGMessage(false);
        navigate('/');
    }

    useEffect(() => {
        apibasic.get(config.CIDADES).then(response => setCidades(response.data))
            .catch(err => {
                console.log(err);
            });
    }, []);

    return <>
        <NavbarVisitante login={openLoginModal} />
        <LoginModal 
            isOpen={isLoginModalOpen} 
            onRequestClose={closeLoginModal} 
        />
        
        <div className="cadastro-container py-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="cadastro-card shadow">
                            <div className="cadastro-header text-center">
                                <img className="cadastro-logo mb-3" src={Logo} alt="Actus Logo" />
                                <h2 className="cadastro-title">Crie sua conta</h2>
                                <p className="cadastro-subtitle text-muted">Preencha os campos abaixo para começar a aproveitar os benefícios</p>
                            </div>

                            <form className="form-cadastro-modern mt-4" onSubmit={(e) => ProcessaCadastro(e)}>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="input-group-custom mb-3">
                                            <label htmlFor="nome">Nome completo</label>
                                            <input type="text" onChange={(e) => setNome(e.target.value)} 
                                                className="form-control-custom" id="nome" placeholder="Digite seu nome completo" required />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <div className="input-group-custom mb-3">
                                            <label htmlFor="email">E-mail</label>
                                            <input type="email" onChange={(e) => setEmail(e.target.value)} 
                                                className="form-control-custom" id="email" placeholder="Digite seu melhor e-mail" required />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="input-group-custom mb-3">
                                            <label htmlFor="senha">Senha</label>
                                            <input type="password" onChange={(e) => setSenha(e.target.value)} 
                                                className="form-control-custom" id="senha" placeholder="Crie uma senha" required />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-group-custom mb-3">
                                            <label htmlFor="senha2">Confirme a Senha</label>
                                            <input type="password" onChange={(e) => setSenha2(e.target.value)} 
                                                className="form-control-custom" id="senha2" placeholder="Repita a senha" required />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="input-group-custom mb-3">
                                            <label htmlFor="whatsup">WhatsApp</label>
                                            <input type="text" onChange={(e) => setWhatsup(e.target.value)} 
                                                className="form-control-custom" id="whatsup" placeholder="(00) 00000-0000" required />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-group-custom mb-3">
                                            <label htmlFor="whatsup2">Confirme o WhatsApp</label>
                                            <input type="text" onChange={(e) => setWhatsup2(e.target.value)} 
                                                className="form-control-custom" id="whatsup2" placeholder="Repita o número" required />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="input-group-custom mb-3">
                                            <label htmlFor="endereco">Endereço</label>
                                            <input type="text" onChange={(e) => setEndereco(e.target.value)} 
                                                className="form-control-custom" id="endereco" placeholder="Rua, Avenida..." required />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="input-group-custom mb-3">
                                            <label htmlFor="numero">Nº</label>
                                            <input type="text" onChange={(e) => setNumero(e.target.value)} 
                                                className="form-control-custom" id="numero" placeholder="Nº" required />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="input-group-custom mb-3">
                                            <label htmlFor="cep">CEP</label>
                                            <input type="text" onChange={(e) => setCEP(e.target.value)} 
                                                className="form-control-custom" id="cep" placeholder="00000-000" required />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="input-group-custom mb-3">
                                            <label htmlFor="complemento">Complemento</label>
                                            <input type="text" onChange={(e) => setComplemento(e.target.value)} 
                                                className="form-control-custom" id="complemento" placeholder="Apto, Bloco..." />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="input-group-custom mb-3">
                                            <label htmlFor="bairro">Bairro</label>
                                            <input type="text" onChange={(e) => setBairro(e.target.value)} 
                                                className="form-control-custom" id="bairro" placeholder="Seu bairro" required />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="input-group-custom mb-3">
                                            <label>Cidade</label>
                                            <SelectCidade 
                                                SalvarCidade={SalvarCidade} 
                                                cidades={cidades} 
                                                cod_cidade={codCidade}
                                                className="form-select-custom"
                                            />
                                        </div>
                                    </div>
                                </div>

                                {mensagem && <div className="alert alert-danger mt-3 py-2 text-center" role="alert">{mensagem}</div>}

                                <button type='submit'
                                    className="btn-cadastro-main w-100 mt-4 py-3"
                                    disabled={loading}>
                                    {loading ? (
                                        <div className="d-flex align-items-center justify-content-center">
                                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                            <span>Processando...</span>
                                        </div>
                                    ) : (
                                        "Criar Minha Conta"
                                    )}
                                </button>
                                
                                <div className="text-center mt-4">
                                    <span className="text-muted">Já tem uma conta? </span>
                                    <Link to="/" onClick={() => setIsLoginModalOpen(true)} className="link-login-direct">Entrar agora</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <DLGMESSAGE
            trigger={ppdlgmessage}
            setTrigger={setPPDLGMessage}
            onConfirma={confirmaCad}
            title={'Cadastro de Usuario'}
            message={dlgmessage}
        />
    </>
}

export default Cadastro;


